
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autori/[slug]/faq",
      function () {
        return require("private-next-pages/autori/[slug]/faq.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autori/[slug]/faq"])
      });
    }
  